import { c as _c } from "react-compiler-runtime";
import { useEffect, useState, useMemo, useRef, useCallback } from 'react';
import { USER_ATTRIBUTES } from 'collaboration-sidebar/constants/userAttributes';
import useUserSettings from 'collaboration-sidebar/hooks/useUserSettings';
import { MODULES_WITH_REPLIES, HIDE_EMBEDDED_COMMENTS } from 'collaboration-sidebar/constants/CollaborationSidebarStateProperties';
import { getAssetKeyFromAsset } from 'collaboration-sidebar/utils/multipleAssets';
import COMMENT_TYPES from '../../../constants/CommentTypes';
import useHasCommentingFeature, { useHasDeepCommentingFeature } from '../../../hooks/useHasCommentingFeature';
import { useRealtimeCommentHandler } from '../../../hooks/useHasUnreadComments';
import * as commentingApi from '../../../api/CommentingV3';
export default function useSetUpEmbeddedComments(t0) {
  "use memo";

  const $ = _c(29);
  const {
    collaborationSidebarState,
    onUpdateCollaborationSidebarState
  } = t0;
  const {
    getUserSetting,
    hasLoaded: userSettingsLoaded
  } = useUserSettings();
  const hasCommentingFeature = useHasCommentingFeature();
  const hasDeepCommentingFeature = useHasDeepCommentingFeature();
  const assetKeyWithFetchedReplies = useRef(null);
  const [hasInitializedHideIndicators, setHasInitializedHideIndicators] = useState(false);
  const {
    objectId,
    objectType,
    isCommentModeActive,
    replyCounts
  } = collaborationSidebarState;
  const currentReplyCounts = useRef(replyCounts);
  let t1;
  let t2;
  if ($[0] !== replyCounts) {
    t1 = () => {
      currentReplyCounts.current = replyCounts;
    };
    t2 = [replyCounts];
    $[0] = replyCounts;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] !== getUserSetting || $[4] !== userSettingsLoaded) {
    t3 = userSettingsLoaded ? getUserSetting(USER_ATTRIBUTES.HIDE_COLLABORATION_SIDEBAR_EMBEDDED_COMMENTS.key) === "true" : true;
    $[3] = getUserSetting;
    $[4] = userSettingsLoaded;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const hideIndicators = t3;
  let t4;
  if ($[6] !== hasDeepCommentingFeature || $[7] !== hideIndicators || $[8] !== isCommentModeActive || $[9] !== objectId || $[10] !== objectType || $[11] !== onUpdateCollaborationSidebarState) {
    t4 = async stale => {
      if (!hasDeepCommentingFeature) {
        return;
      }
      const assetKey = getAssetKeyFromAsset({
        objectId: objectId || "",
        objectType: objectType || ""
      });
      if ((!hideIndicators || isCommentModeActive) && objectId && objectType && (assetKeyWithFetchedReplies.current !== assetKey || stale)) {
        var _response$results$fil, _response$results;
        const response = await commentingApi.fetchCommentsCached({
          objectType,
          objectId,
          refetch: !!stale
        });
        const replyComments = (_response$results$fil = (_response$results = response.results) === null || _response$results === void 0 ? void 0 : _response$results.filter(_temp)) !== null && _response$results$fil !== void 0 ? _response$results$fil : [];
        const replyCommentsMap = replyComments.reduce(_temp2, {});
        assetKeyWithFetchedReplies.current = assetKey;
        onUpdateCollaborationSidebarState({
          [MODULES_WITH_REPLIES]: replyCommentsMap
        });
        const latestReplyCounts = await commentingApi.fetchCommentRepliesCount({
          objectType,
          objectId,
          commentIds: replyComments.map(_temp3)
        });
        onUpdateCollaborationSidebarState({
          replyCounts: Object.assign({}, currentReplyCounts.current, latestReplyCounts)
        });
      }
    };
    $[6] = hasDeepCommentingFeature;
    $[7] = hideIndicators;
    $[8] = isCommentModeActive;
    $[9] = objectId;
    $[10] = objectType;
    $[11] = onUpdateCollaborationSidebarState;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  const fetchEmbeddedComments = t4;
  const t5 = objectType || undefined;
  const t6 = objectId || undefined;
  const t7 = !hasCommentingFeature;
  let t8;
  if ($[13] !== fetchEmbeddedComments) {
    t8 = () => void fetchEmbeddedComments(true);
    $[13] = fetchEmbeddedComments;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t5 || $[16] !== t6 || $[17] !== t7 || $[18] !== t8) {
    t9 = {
      objectType: t5,
      objectId: t6,
      skip: t7,
      callback: t8
    };
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  useRealtimeCommentHandler(t9);
  let t10;
  let t11;
  if ($[20] !== fetchEmbeddedComments) {
    t10 = () => {
      fetchEmbeddedComments().catch(_temp4);
    };
    t11 = [fetchEmbeddedComments];
    $[20] = fetchEmbeddedComments;
    $[21] = t10;
    $[22] = t11;
  } else {
    t10 = $[21];
    t11 = $[22];
  }
  useEffect(t10, t11);
  let t12;
  let t13;
  if ($[23] !== hasInitializedHideIndicators || $[24] !== hideIndicators || $[25] !== onUpdateCollaborationSidebarState || $[26] !== userSettingsLoaded) {
    t12 = () => {
      if (!hasInitializedHideIndicators && userSettingsLoaded) {
        onUpdateCollaborationSidebarState({
          [HIDE_EMBEDDED_COMMENTS]: hideIndicators
        });
        setHasInitializedHideIndicators(true);
      }
    };
    t13 = [hasInitializedHideIndicators, hideIndicators, userSettingsLoaded, onUpdateCollaborationSidebarState];
    $[23] = hasInitializedHideIndicators;
    $[24] = hideIndicators;
    $[25] = onUpdateCollaborationSidebarState;
    $[26] = userSettingsLoaded;
    $[27] = t12;
    $[28] = t13;
  } else {
    t12 = $[27];
    t13 = $[28];
  }
  useEffect(t12, t13);
}
function _temp4(__e) {}
function _temp3(comment_1) {
  return comment_1.id;
}
function _temp2(repliesAcc, comment_0) {
  var _comment_0$parentId;
  repliesAcc[(_comment_0$parentId = comment_0.parentId) !== null && _comment_0$parentId !== void 0 ? _comment_0$parentId : ""] = comment_0;
  return repliesAcc;
}
function _temp(comment) {
  return comment.type === COMMENT_TYPES.DEEP_COMMENT && comment.parentId;
}